const STEPS = [
  {
    num: '01',
    title: 'Analýza & Stratégia',
    desc: 'Bezplatný 30-minútový hovor, kde pochopíme vaše ciele, cieľovú skupinu a súčasný stav. Vytvoríme konkrétny akčný plán.',
  },
  {
    num: '02',
    title: 'Dizajn & Vývoj',
    desc: 'Pracujeme rýchlo a transparentne. Dostávate náhľady, môžete komentovať a sledovať postup. Typický web do 7 pracovných dní.',
  },
  {
    num: '03',
    title: 'Spustenie & Rast',
    desc: 'Spustíme projekt, zaškolíme vás a zostaneme po vašom boku. Výsledky meriame, optimalizujeme a rastieme spolu s vami.',
  },
];

export default function HowItWorks() {
  return (
    <section id="postup" aria-labelledby="postup-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-tag fade-up">Postup</span>
          <h2 id="postup-heading" className="section-h2 fade-up delay-1">
            Ako to <span className="grad">funguje</span>
          </h2>
          <p className="section-sub fade-up delay-2">
            Od prvého hovoru po spustený projekt – transparentne a rýchlo.
          </p>
        </div>
        <div className="steps-grid">
          {STEPS.map((s, i) => (
            <div key={s.num} className={`step-card fade-up${i > 0 ? ` delay-${i}` : ''}`}>
              <div className="step-num-bg" aria-hidden="true">{s.num}</div>
              <div className="step-dot" aria-hidden="true">{i + 1}</div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
